module.exports = __webpack_public_path__ + "img/heiltherme_oesterreich_logo_765c53b3.fbc01388.svg";